<template>
  <div class="login-wrap">
    <div class="layout">
      <Spin fix v-if="loading"></Spin>
      <!-- 主体登录区域 -->
      <div class="main" :style="{ height: this.backgroundImgHeight + 'px' }">
        <Card dis-hover class="login">
          <div v-if="switchBox == 1">
            <!-- <div class="ercode_tab swicth-ercode" @click="switchChange(2)">
              <img
                src="https://img.alicdn.com/imgextra/i1/O1CN01a2J40d1HtlqT5oBD8_!!6000000000816-2-tps-204-204.png"
                data-spm-anchor-id="0.0.0.i1.2d7d7435N9bfMP"
                style="width: 52px; height: 52px"
              />
            </div> -->
            <div
              :style="{
                textAlign: 'center',
                marginBottom: !isIframe ? '40px' : '55px',
              }"
            >
              <img
                src="../../assets/images/login-logo.png"
                alt=""
                v-if="!isIframe"
              />
            </div>
            <h2 v-if="isIframe" style="text-align: center; margin-bottom: 20px">
              登录
            </h2>
            <Form :model="form">
              <!-- 用户名 -->
              <FormItem
                class="username"
                prop="userNameOrEmailAddress"
                :rules="{ required: true, message: '用户名不能为空!' }"
              >
                <Input
                  v-model.trim="form.userNameOrEmailAddress"
                  prefix="ios-person-outline"
                  placeholder="请输入您的账号"
                  @keyup.enter="login"
                  style="width: 320px"
                  type="text"
                  size="large"
                />
              </FormItem>
              <!-- 密码 -->
              <FormItem
                class="password"
                prop="password"
                :rules="{ required: true, message: '密码不能为空!' }"
              >
                <Input
                  v-model.trim="form.password"
                  prefix="ios-lock-outline"
                  placeholder="请输入您的密码"
                  @keyup.enter="login"
                  style="width: 320px"
                  type="password"
                  size="large"
                />
              </FormItem>
              <!-- 验证码 -->
              <FormItem
                class="code"
                prop="code"
                :rules="{ required: true, message: '验证码不能为空!' }"
              >
                <Row>
                  <i-col span="12">
                    <Input
                      id="rzCode"
                      v-model="form.code"
                      placeholder="验证码"
                      @on-enter="login"
                    />
                  </i-col>
                  <i-col span="12">
                    <img
                      :src="rzCode.imgUrl"
                      @click="getImg"
                      alt="验证码"
                      style="
                        vertical-align: middle;
                        padding-left: 16px;
                        height: 32px;
                      "
                    />
                    <a href="#" @click="btnclick">换一张</a>
                  </i-col>
                </Row>
              </FormItem>
              <!-- 登录按钮 -->
              <FormItem>
                <Button
                  class="submit"
                  @click="login"
                  :style="{
                    background:
                      form.userNameOrEmailAddress && loginType == 0
                        ? '#7150e7'
                        : '#999',
                  }"
                  :disabled="loginType != 0"
                  >{{ btnTitle }}</Button
                >
              </FormItem>
            </Form>

            <!-- <div class="verification-box">
              <a @click="register" style="float: left">用户注册</a>
              <a @click="retrieve" style="float: right">找回密码</a>
            </div> -->
            <!-- <div class="other-login">
              <div class="other-separate"></div>
              <div class="other-text">其他方式登录</div>
              <div class="other-separate"></div>
            </div> -->
            <div class="socialLogin" style="display: none">
              <span class="socialButtonGroup" @click="handLoginByWx">
                <img src="../../assets/images/wx-login.png" />
              </span>
            </div>
          </div>
          <div v-if="switchBox == 2">
            <div class="ercode_tab swicth-ercode" @click="switchChange(1)">
              <img
                src="https://img.alicdn.com/imgextra/i2/O1CN01yJNaqi1i2dWMOvg60_!!6000000004355-2-tps-204-204.png"
                data-spm-anchor-id="0.0.0.i1.2d7d7435N9bfMP"
                style="width: 52px; height: 52px"
              />
            </div>
            <div>
              <div class="ercodeContent">
                <div class="Qrcode-title">扫码登录</div>
                <div class="ercodeBox">
                  <div
                    ref="qrCodeDiv"
                    class="ewm-box"
                    @click="renovatePage"
                  ></div>
                  <p>
                    打开<a href="#" target="_blank" rel="noopener noreferrer">
                      在线教育App</a
                    >
                  </p>
                  <p>在「我的」页面右上角打开扫一扫</p>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <!-- 页面尾部 -->
      <div class="footer" v-if="!isIframe">
        Copyright &copy; {{ time }}. All Rights Reserved 技术支持：<a
          href="http://www.zhijiao361.com/"
          target="_blank"
          >安徽渔之蓝教育软件技术有限公司</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Vue from "vue";
import guid from "@/utils/guid.js";
import md5 from "js-md5";

export default {
  data() {
    return {
      // 登录所需要的字段
      form: {
        userNameOrEmailAddress: "",
        password: "",
        code: "",
        rememberClient: false,
      },
      user: {},
      time: "",
      loginType: 0, //登录的状态码
      rzCode: {
        //验证码
        imgUrl: "",
        md5: "",
      },
      backgroundImgHeight: null, // 背景图片高度
      returnurl: "",
      loading: false,
      QRImgUrl: Math.uuid(),
      switchBox: 1,
      timer: "",
      goEasyOTP: "",
      wxModal: false,
      wxLogin: {
        appid: "wxbe7ed02d6940aa0d",
        scope: "snsapi_login",
        redirect_uri: "https://ahjxjysso.ahjxjy.cn",
        state: "https://ahjxjysso.ahjxjy.cn",
        AppSecret: "3c58ba8b5147c4772afcdc797bbf79a3",
      },
      isIframe: false,
    };
  },
  computed: {
    //登录按钮的loading状态
    btnTitle() {
      let btnText = {
        0: "立即登录",
        1: "登录中...",
        2: "登录成功",
      };
      return btnText[this.loginType];
    },
  },
  created() {},
  watch: {
    $route: {
      handler: function(route) {
        if (route.query.code) {
          this.wxLoginChange(route.query.code);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isIframe = document.body.clientWidth < 700;
    let sqCode = sessionStorage.getItem("sqCode");
    let platform = sessionStorage.getItem("platform");
    let sq = {
      "xwyy/": "xwyyReturnUrl",
      "zkzx/": "zkzxReturnUrl",
      "zjxks/": "zjxksReturnUrl",
    };
    if (platform == "null") {
      platform = "xwyy/";
    }
    if (sqCode) {
      this.$api.account.isLogin().then((res) => {
        if (res) {
          this.$authServices.logout();
        } else {
          this.loading = true;
          // 登录请求
          let postData = {
            sqCode,
            returnurl: this.$config[sq[platform]],
          };
          this.$api.account
            .qsLogin(postData)
            .then((res) => {
              sessionStorage.removeItem("sqCode");
              localStorage.setItem("user", JSON.stringify(res.userInfo));
              location.href =
                res.returnUrl ||
                this.$config.baseUrl + "/userinfo/chooseModule";
            })
            .catch((error) => {
              this.loading = false;
              sessionStorage.removeItem("sqCode");
              this.$message.error("授权失败！请稍后再试。");
            });
        }
      });
    } else {
      this.$authServices.getAuthState().then((res) => {
        if (!res && location.href.indexOf("?ReturnUrl") == -1) {
          this.$router.push("/");
        }
        if (res) {
          this.$router.push("/");
        }
      });
      this.time = new Date().getFullYear();
      this.getImg(); // 调用验证码
      this.returnurl = this.$route.query.ReturnUrl;
    }
    this.getObtainOTP();
  },
  methods: {
    // 登录时间
    login() {
      localStorage.clear();
      sessionStorage.clear();
      this.clearCookie();
      const { userNameOrEmailAddress, password, code } = this.form;
      if (!userNameOrEmailAddress) {
        return;
      }
      if (!password) {
        this.warnShow("请输入密码!");
        return;
      }
      if (!code) {
        this.warnShow("请输入验证码!");
        return;
      }
      this.loginType = 1;
      // 登录时所携带的参数
      let postData = {
        Username: userNameOrEmailAddress,
        password: md5(password).toUpperCase(),
        //  password: password,
        rememberLogin: false,
        returnurl: this.returnurl,
        cancel: false,
        md5key: this.rzCode.md5,
        verifyCode: code,
      };
      // 登录请求
      this.$api.account
        .login(postData)
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.userInfo));
          location.href =
            res.returnUrl || this.$config.baseUrl + "/userinfo/chooseModule";
          // "http://localhost:8017" + "/userinfo/chooseModule";
        })
        .catch((error) => {
          this.$Message.error(error.error.message);
          this.loginType = 0;
          this.getImg();
        });
    },

    //清空cookie
    clearCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; ) {
          document.cookie =
            keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下的,例如：m.kevis.com
          document.cookie =
            keys[i] +
            "=0;path=/;domain=" +
            document.domain +
            ";expires=" +
            new Date(0).toUTCString(); //清除当前域名下的，例如 .m.kevis.com
          document.cookie =
            keys[i] +
            "=0;path=/;domain=kevis.com;expires=" +
            new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
        }
      }
    },
    async getImg() {
      let _this = this;
      let r = await this.$api.account.getImg({ time: new Date().getTime() });
      if (!r) {
        this.warnShow("发生错误，请稍后重试");
        return false;
      }
      let $data = r;
      _this.rzCode.imgUrl = "data:image/jpg;base64," + $data.code;
      _this.rzCode.md5 = $data.md5Key;
    },
    btnclick() {
      this.getImg();
    },
    warnShow(title, callback) {
      this.$Modal.error({
        title: "提示",
        content: title,
        onOk: () => {
          callback && callback();
        },
      });
    },
    logout() {
      this.$Modal.error({
        title: "提示",
        content: "您确认要退出登录吗？",
        onOk: () => {
          this.$authServices.logout();
        },
      });
    },
    switchChange(i) {
      this.switchBox = i;
      if (i == 2) {
        this.getQRcode();
      }
    },
    getQRcode() {
      setTimeout(() => {
        new QRCode(this.$refs.qrCodeDiv, {
          text: this.QRImgUrl,
          width: 250,
          height: 250,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          errorCorrectionLevel: "L", //容错率，L/M/H
        });
      }, 0);
    },
    /**
     * @description:
     * @return {*}
     */

    register() {
      let url = Vue.prototype.$config.baseUrl;
      window.open(url + "/register.html");
    },
    /**
     * @description: 找回密码
     * @return {*}
     */

    retrieve() {
      let url = Vue.prototype.$config.baseUrl;
      window.open(url + "/recoverMailbox.html");
    },
    /**
     * @description: 获取GoEasy需要的OTP
     * @return {*}
     */

    getObtainOTP() {
      this.$api.account.getGoEasy().then((res) => {
        this.goEasyOTP = res;
        this.getGoeasy();
      });
    },
    /**
     * @description: 判断goEasy 连接状态
     * @return {*}
     */

    getGoeasy() {
      let _this = this;

      _this.goeasy.connect({
        otp: _this.goEasyOTP,
        onSuccess: function() {
          //连接成功

          console.log("连接成功.", 1111111111); //连接成功
          _this.getDecideState();
        },
        onFailed: function(error) {
          //连接失败
          console.log(
            "连接失败, code:" + error.code + ",error:" + error.content,
            222222222222
          );
        },
        onProgress: function(attempts) {
          //连接或自动重连中
          console.log("连接或自动重连中", attempts, 33333333333);
        },
      });
    },
    /**
     * @description: goEasy 连接成功后，将返回值提交给后台
     * @return {*}
     */

    getDecideState() {
      let _this = this;
      var pubsub = _this.goeasy.pubsub;
      pubsub.subscribe({
        channel: _this.QRImgUrl, //替换为您自己的channel
        onMessage: function(message) {
          console.log(
            "Channel:" + message.channel + " content:" + message.content,
            666666
          );
          console.log(message.content);
          _this.getRequestCode(JSON.parse(message.content));
        },
        onSuccess: function() {
          console.log("Channel订阅成功。");
        },
        onFailed: function(error) {
          console.log(
            "Channel订阅失败, 错误编码：" +
              error.code +
              " 错误信息：" +
              error.content
          );
        },
      });
    },
    /**
     * @description: 根据回调内容请求接口操作二维码
     * @return {*}
     */

    getRequestCode(item) {
      let postData = {
        UserId: item.UserId,
        loginCode: item.Code,
        ReturnUrl: this.returnurl,
      };
      this.$api.account.isQRLogin(postData).then((res) => {
        localStorage.setItem("user", JSON.stringify(res.userInfo));
        location.href =
          res.returnUrl || this.$config.baseUrl + "/userinfo/chooseModule";
      });
    },
    renovatePage() {
      this.$refs.qrCodeDiv.innerHTML = "";
      this.QRImgUrl = Math.uuid();
      this.getQRcode();
    },
    /**
     * @description: wx login
     * @return {*}
     */

    handLoginByWx() {
      // this.wxModal = true;
      const hrefUrl = window.location.href;
      window.open(
        `https://open.weixin.qq.com/connect/qrconnect?appid=${
          this.wxLogin.appid
        }&redirect_uri=${encodeURIComponent(
          hrefUrl
        )}&response_type=code&scope=snsapi_login&state=${
          this.wxLogin.state
        }#wechat_redirect`,
        "_self"
      );
    },
    wxLoginChange(value) {
      let getData = {
        appid: this.wxLogin.appid,
        secret: this.wxLogin.AppSecret,
        code: value,
        grant_type: "authorization_code",
      };
      let url = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${this.wxLogin.appid}&secret=${this.wxLogin.AppSecret}&code=${value}&grant_type=authorization_code`;
      // this.$axios
      //   .get("https://api.weixin.qq.com/sns/oauth2/access_token", {
      //     params: getData,
      //   })
      //   .then((res) => {
      //     console.log(res);
      //   });

      jQuery.ajax({
        url: url,
        type: "get",
        dataType: "jsonp", // 请求方式为jsonp
        crossDomain: true,
        success: function(data) {
          debugger;
          console.log(data);
        },
      });
    },
  },
};
</script>
<style>
/* .login_tabs {
  .ivu-tabs-bar {
    border-bottom: none;
  }
} */
</style>
<style scoped>
ul,
li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.login-wrap {
  position: relative;
  height: 100%;
  width: 100%;
}
.header {
  height: 110px;
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: center;
}
.header p {
  font-size: 30px;
  overflow: hidden;
  color: #333333;
  margin-left: 20px;
  font-weight: bold;
  text-align: center;
  line-height: 110px;
}
.main {
  height: calc(100vh - 41px);
  background: url("../../assets/images/Background-pic.jpg") no-repeat;
  background-size: cover;
}
.ivu-card {
  max-width: 600px;
  width: 100%;
  height: 466px;
  border-radius: 30px;
  position: relative;
  transform: translate(-50%, -46%);
  left: 50%;
  top: 50%;
  background: url("../../assets/images/form.jpg") no-repeat;
  background-size: cover;
  background-position: 0% 60%;
}
.ivu-form {
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  /*  margin-top: 30px; */
}
.code a {
  border: 0;
  background: #fff;
  border-bottom: 1px solid #ccc;
  outline: none;
  margin-left: 3px;
  color: #ccc;
  height: 28px;
}
.ivu-form-item {
  width: 320px;
  height: 40px;
}
.ivu-input-wrapper {
  height: 40px;
  border: 0;
  outline: none;
}
.ivu-input-wrapper input {
  border: 0;
  border-radius: 30px;
}
.login >>> .ivu-btn {
  width: 320px;
  height: 40px;
  border-radius: 20px;
  border: 0;
  outline: none;
  font-size: 16px;
  color: #fff;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  background: #fff;
  text-align: center;
  padding: 10px 0;
  color: #000;
}
.footer > a {
  color: #000;
}
.ivu-form-item-error >>> .ivu-input:hover {
  border-color: #6035ed;
}
.login-wrap >>> .ivu-input:hover {
  border-color: #6035ed;
}
.ivu-form-item-error >>> .ivu-input {
  border: 1px solid #6035ed;
}
.ivu-input-wrapper-large >>> .ivu-input-prefix i {
  font-size: 25px;
  line-height: 40px;
  margin-left: 10px;
}
.login-wrap >>> .ivu-input {
  border-radius: 20px;
  padding-left: 35px;
}
/* >>> .ivu-form-item-error-tip {
  left: 20px;
  color: #6035ed;
} */
.item {
  padding: 10px 25px;
  background: #aeb4cb;
  display: inline-block;
  border-radius: 8px;
  margin: 5px 3px;
}
.item a {
  color: #fff;
}
.dropOut {
  position: absolute;
  right: 40px;
  bottom: 40px;
}

.ercode_tab {
  position: absolute;
  width: 52px;
  height: 52px;
  top: 0;
  right: 0;
}
.ercodeContent {
  text-align: center;
}
.Qrcode-title {
  font-size: 24px;
  color: #1a1a1a;
  line-height: 33px;
  margin-bottom: 50px;
  margin-top: 3px;
}
.ercodeBox {
  height: 210px;
}

.ercodeBox .Qrcode-img {
  margin: 0 auto 15px;
  line-height: 0;
  height: 150px;
  width: 150px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.ewm-box {
  width: 250px;
  margin: 0 auto 15px;
}
.verification-box {
  width: 55%;
  margin: 0 auto;
  overflow: hidden;
}
.other-login {
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0 24px 12px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.other-login .other-separate {
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  border-top: 1px solid;
  border-color: #ebebeb;
  width: 205px;
}
.other-login .other-text {
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  color: #999999;
  font-size: 12px;
  margin-left: 16px;
  margin-right: 16px;
  width: 72px;
  overflow: hidden;
  line-height: 17px;
  white-space: nowrap;
}
.socialLogin {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
}
.socialButtonGroup {
  margin: auto;
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
}
</style>
<style>
.wxLogin .ivu-modal-body {
  text-align: center;
}
</style>
